module.exports = __webpack_public_path__ + "img/adv_gnd.cdc2262b.png";